import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { logger } from '@heidi/runtime/logger';
import { useMutation } from '@tanstack/react-query';
import { shareUserDocumentByEmail } from '../../../../data/library/user-documents/api';

export function useShareUserDocumentByEmail(documentId: string | null) {
  const { t } = useTranslations();

  return useMutation({
    mutationFn: async (email: string) => {
      if (!documentId) throw new Error('No document ID provided');
      return shareUserDocumentByEmail(documentId, email);
    },
    onSuccess: () => {
      toast({
        tone: 'success',
        title: t('sendAsEmailModal.emailSentSuccessfully'),
      });
    },
    onError: (error) => {
      logger.error('Failed to share document by email:', error);
      toast({
        tone: 'destructive',
        title: t('sendAsEmailModal.error'),
      });
    },
  });
}
